import {
  getUserInCompaniesbyUserId,
  getUserCompanyDatabyComapanyId,
} from '@/services/eserv-api';
import {
  getAccountingOpenInvoices,
  getAccountingClosedInvoices,
  getAccountingHistoricalInvoices,
  getTransactionRefunds,
  getAccountingUserCredits,
  getAccountingUserCreditById,
  getInvoiceById,
  getInvoiceByNumber,
  getAccountingPaymentTypes,
  getAccountingCreditCardTypes,
  processInvoiceApprove,
  processInvoiceResetPaymentType,
  processInvoiceCancel,
  processInvoiceWO,
  processInvoiceRefund,
  processInvoiceGroup,
  processUserCredit,
  getProducts,
  getProductsByCategory,
  getProductTypeList,
  getPriceByProductID,
  setInvoice,
} from './services/accounting-api';
import {
  getOpenPermits,
  getOPFeeList,
  getOPFeeByID,
} from './services/misc-invoice-api';

export const SET_ACCOUNTING_OPEN_INVOICES = 'accounting/SET_ACCOUNTING_OPEN_INVOICES ';
export const SET_ACCOUNTING_CLOSED_INVOICES = 'accounting/SET_ACCOUNTING_CLOSED_INVOICES ';
export const SET_ACCOUNTING_HISTORICAL_INVOICES = 'accounting/SET_ACCOUNTING_HISTORICAL_INVOICES ';
export const SET_ACCOUNTING_TRANSACTION_REFUNDS = 'accounting/SET_ACCOUNTING_TRANSACTION_REFUNDS ';
export const SET_ACCOUNTING_USER_CREDITS = 'accounting/SET_ACCOUNTING_USER_CREDITS ';
export const SET_SELECTED_INVOICE = 'accounting/SET_SELECTED_INVOICE';
export const SET_SELECTED_ORIGINAL_INVOICE = 'accounting/SET_SELECTED_ORIGINAL_INVOICE';
export const SET_SELECTED_USER_CREDIT = 'accounting/SET_SELECTED_USER_CREDIT';
export const SET_SELECTED_INVOICE_COMPANY = 'accounting/SET_SELECTED_INVOICE_COMPANY';
export const SET_SELECTED_USER_COMPANY = 'accounting/SET_SELECTED_USER_COMPANY';
export const SET_ACCOUNTING_PAYMENT_TYPES = 'accounting/SET_ACCOUNTING_PAYMENT_TYPES';
export const SET_ACCOUNTING_CREDITCARD_TYPES = 'accounting/SET_ACCOUNTING_CREDITCARD_TYPES';
export const SET_PREVIOUS_ACCOUNTING_TAB = 'accounting/SET_PREVOUS_ACCOUNTING_TAB';
export const FETCH_INVOICE_BY_ID = 'accounting/FETCH_INVOICE_BY_ID';
export const FETCH_ORIGINAL_INVOICE_BY_ID = 'accounting/FETCH_ORIGINAL_INVOICE_BY_ID';
export const FETCH_ORIGINAL_INVOICE_BY_NUMBER = 'accounting/FETCH_ORIGINAL_INVOICE_BY_NUMBER';
export const FETCH_ACCOUNTING_OPEN_INVOICES = 'accounting/FETCH_ACCOUNTING_OPEN_INVOICES ';
export const FETCH_ACCOUNTING_CLOSED_INVOICES = 'accounting/FETCH_ACCOUNTING_CLOSED_INVOICES ';
export const FETCH_ACCOUNTING_HISTORICAL_INVOICES = 'accounting/FETCH_ACCOUNTING_HISTORICAL_INVOICES ';
export const FETCH_ACCOUNTING_TRANSACTION_REFUNDS = 'accounting/FETCH_ACCOUNTING_TRANSACTION_REFUNDS ';
export const FETCH_ACCOUNTING_USER_CREDITS = 'accounting/FETCH_ACCOUNTING_USER_CREDITS ';
export const FETCH_USER_CREDIT_BY_ID = 'accounting/FETCH_USER_CREDIT_BY_ID ';
export const GET_SELECTED_INVOICE_COMPANY_BY_USERID = 'accounting/GET_SELECTED_INVOICE_COMPANY_BY_USERID';
export const GET_SELECTED_USER_COMPANY_BY_USERID = 'accounting/GET_SELECTED_USER_COMPANY_BY_USERID';
export const FETCH_ACCOUNTING_PAYMENT_TYPES = 'accounting/FETCH_ACCOUNTING_PAYMENT_TYPES';
export const FETCH_ACCOUNTING_CREDITCARD_TYPES = 'accounting/FETCH_ACCOUNTING_CREDITCARD_TYPES';
export const PROCESS_INVOICE_APPROVE = 'accounting/PROCESS_INVOICE_APPROVE';
export const PROCESS_INVOICE_RESET_PAYMENT_TYPE = 'accounting/PROCESS_INVOICE_RESET_PAYMENT_TYPE';
export const PROCESS_INVOICE_CANCEL = 'accounting/PROCESS_INVOICE_CANCEL';
export const PROCESS_INVOICE_WO = 'accounting/PROCESS_INVOICE_WO';
export const PROCESS_INVOICE_REFUND = 'accounting/PROCESS_INVOICE_REFUND';
export const PROCESS_INVOICE_GROUP = 'accounting/PROCESS_INVOICE_GROUP';
export const PROCESS_USER_CREDIT = 'accounting/PROCESS_USER_CREDIT';
export const GET_OPEN_PERMITS = 'accounting/GET_OPEN_PERMITS';
export const SET_OPEN_PERMITS = 'accounting/SET_OPEN_PERMITS';
export const GET_PRODUCTS = 'accounting/GET_PRODUCTS';
export const SET_PRODUCTS = 'accounting/SET_PRODUCTS';
export const GET_PRODUCTS_BY_CATEGORY = 'accounting/GET_PRODUCTS_BY_CATEGORY';
export const SET_PRODUCTS_BY_CATEGORY = 'accounting/SET_PRODUCTS_BY_CATEGORY';
export const GET_PRODUCTS_TYPE_LIST = 'accounting/GET_PRODUCTS_TYPE_LIST';
export const SET_PRODUCTS_TYPE_LIST = 'accounting/SET_PRODUCTS_TYPE_LIST';
export const GET_PRICE_BY_PRODUCTID = 'accounting/GET_PRICE_BY_PRODUCTID';
export const SET_PRICE_BY_PRODUCTID = 'accounting/SET_PRICE_BY_PRODUCTID';
export const SET_INVOICE = 'accounting/SET_INVOICE';
export const GET_OP_FEE = 'accounting/GET_OP_FEE';
export const SET_OP_FEE = 'accounting/SET_OP_FEE';
export const GET_OP_FEE_BY_ID = 'accounting/GET_OP_FEE_BY_ID';
export const SET_OP_FEE_BY_ID = 'accounting/SET_OP_FEE_BY_ID';
export const SET_SELECTED_GROUP_INVOICE_IDS = 'accounting/SET_SELECTED_GROUP_INVOICE_IDS';

export const accountingStore = {
  state: {
    accountingOpenInvoices: null,
    accountingClosedInvoices: null,
    accountingHistoricalInvoices: null,
    accountingTransactionRefunds: null,
    accountingUserCredits: null,
    accountingSelectedInvoice: null,
    accountingSelectedOriginalInvoice: null,
    accountingSelectedInvoiceCompany: null,
    accountingSelectedUserCompany: null,
    accountingSelectedUserCredit: null,
    accountingPaymentTypes: null,
    accountingCreditCardTypes: null,
    previousAccountingTab: -1,
    openPermits: null,
    products: null,
    opFeeList: null,
    selectedGroupInvoiceIds: null,
  },
  mutations: {
    [SET_ACCOUNTING_OPEN_INVOICES](state, { invoices }) {
      state.accountingOpenInvoices = invoices;
    },
    [SET_ACCOUNTING_CLOSED_INVOICES](state, { invoices }) {
      state.accountingClosedInvoices = invoices;
    },
    [SET_ACCOUNTING_HISTORICAL_INVOICES](state, { invoices }) {
      state.accountingHistoricalInvoices = invoices;
    },
    [SET_ACCOUNTING_TRANSACTION_REFUNDS](state, { invoices }) {
      state.accountingTransactionRefunds = invoices;
    },
    [SET_ACCOUNTING_USER_CREDITS](state, { credits }) {
      state.accountingUserCredits = credits;
    },
    [SET_SELECTED_INVOICE](state, { invoice }) {
      state.accountingSelectedInvoice = invoice;
    },
    [SET_SELECTED_ORIGINAL_INVOICE](state, { invoice }) {
      state.accountingSelectedOriginalInvoice = invoice;
    },
    [SET_SELECTED_USER_CREDIT](state, { credit }) {
      state.accountingSelectedUserCredit = credit;
    },
    [SET_SELECTED_INVOICE_COMPANY](state, { company }) {
      state.accountingSelectedInvoiceCompany = company;
    },
    [SET_SELECTED_USER_COMPANY](state, { company }) {
      state.accountingSelectedUserCompany = company;
    },

    [SET_ACCOUNTING_PAYMENT_TYPES](state, { types }) {
      state.accountingPaymentTypes = types;
    },
    [SET_ACCOUNTING_CREDITCARD_TYPES](state, { types }) {
      state.accountingCreditCardTypes = types;
    },
    [SET_PREVIOUS_ACCOUNTING_TAB](state, { previousTab }) {
      state.previousAccountingTab = previousTab;
    },
    [SET_OPEN_PERMITS](state, { openPermits }) {
      state.openPermits = openPermits;
    },
    [SET_PRODUCTS](state, { products }) {
      state.products = products;
    },
    [SET_PRODUCTS_BY_CATEGORY](state, { products }) {
      state.products = products;
    },
    [SET_PRODUCTS_TYPE_LIST](state, { products }) {
      state.products = products;
    },
    [SET_PRICE_BY_PRODUCTID](state, { productPrice }) {
      state.productPrice = productPrice;
    },
    [SET_OP_FEE](state, { opFeeList }) {
      state.opFeeList = opFeeList;
    },
    [SET_OP_FEE_BY_ID](state, { opFeeList }) {
      state.opFeeList = opFeeList;
    },
    [SET_SELECTED_GROUP_INVOICE_IDS](state, selectedInvoiceIdList) {
      state.selectedGroupInvoiceIds = selectedInvoiceIdList;
    },
  },
  getters: {
    accountingOpenInvoices: (state) => state.accountingOpenInvoices,
    accountingSelectedInvoiceIds: (state) => state.selectedGroupInvoiceIds,
    accountingClosedInvoices: (state) => state.accountingClosedInvoices,
    accountingHistoricalInvoices: (state) => state.accountingHistoricalInvoices,
    accountingTransactionRefunds: (state) => state.accountingTransactionRefunds,
    accountingUserCredits: (state) => state.accountingUserCredits,
    accountingSelectedInvoice: (state) => state.accountingSelectedInvoice,
    accountingSelectedOriginalInvoice: (state) => state.accountingSelectedOriginalInvoice,
    accountingSelectedUserCredit: (state) => state.accountingSelectedUserCredit,
    accountingSelectedInvoiceCompany: (state) => state.accountingSelectedInvoiceCompany,
    accountingSelectedUserCompany: (state) => state.accountingSelectedUserCompany,
    accountingPaymentTypes: (state) => state.accountingPaymentTypes,
    accountingCreditCardTypes: (state) => state.accountingCreditCardTypes,
    previousAccountingTab: (state) => state.previousAccountingTab,
    openPermits: (state) => state.openPermits,
    products: (state) => state.products,
  },

  actions: {
    [FETCH_ACCOUNTING_OPEN_INVOICES]: async ({ commit }) => {
      try {
        return await getAccountingOpenInvoices()
          .then((resp) => {
            commit(SET_ACCOUNTING_OPEN_INVOICES, { invoices: resp.data });
          }).catch((error) => {
            commit(SET_ACCOUNTING_OPEN_INVOICES, { invoices: null });
            console.error(`get_accounting_err:${error.Status}`);
          });
      } catch (error) {
        commit(SET_ACCOUNTING_OPEN_INVOICES, { invoices: null });
        console.error(`getaccounting_err:${error.Status}`);
        throw error;
      }
    },
    [FETCH_ACCOUNTING_CLOSED_INVOICES]: async ({ commit }) => {
      try {
        return await getAccountingClosedInvoices()
          .then((resp) => {
            commit(SET_ACCOUNTING_CLOSED_INVOICES, { invoices: resp.data });
          }).catch((error) => {
            commit(SET_ACCOUNTING_CLOSED_INVOICES, { invoices: null });
            console.error(`get-accounting_err:${error.Status}`);
          });
      } catch (error) {
        commit(SET_ACCOUNTING_CLOSED_INVOICES, { invoices: null });
        console.error(`get_accounting_err:${error.Status}`);
        throw error;
      }
    },
    [FETCH_ACCOUNTING_HISTORICAL_INVOICES]: async ({ commit }) => {
      try {
        return await getAccountingHistoricalInvoices()
          .then((resp) => {
            commit(SET_ACCOUNTING_HISTORICAL_INVOICES, { invoices: resp.data });
          }).catch((error) => {
            commit(SET_ACCOUNTING_HISTORICAL_INVOICES, { invoices: null });
            console.error(`get-accounting_err:${error.Status}`);
          });
      } catch (error) {
        commit(SET_ACCOUNTING_HISTORICAL_INVOICES, { invoices: null });
        console.error(`get_accounting_err:${error.Status}`);
        throw error;
      }
    },
    [FETCH_ACCOUNTING_TRANSACTION_REFUNDS]: async ({ commit }) => {
      try {
        return await getTransactionRefunds()
          .then((resp) => {
            commit(SET_ACCOUNTING_TRANSACTION_REFUNDS, { invoices: resp.data });
          }).catch((error) => {
            commit(SET_ACCOUNTING_TRANSACTION_REFUNDS, { invoices: null });
            console.error(`get-accounting_err:${error.Status}`);
          });
      } catch (error) {
        commit(SET_ACCOUNTING_TRANSACTION_REFUNDS, { invoices: null });
        console.error(`get_accounting_err:${error.Status}`);
        throw error;
      }
    },
    [FETCH_ACCOUNTING_USER_CREDITS]: async ({ commit }) => {
      try {
        return await getAccountingUserCredits()
          .then((resp) => {
            commit(SET_ACCOUNTING_USER_CREDITS, { credits: resp.data });
          }).catch((error) => {
            commit(SET_ACCOUNTING_USER_CREDITS, { credits: null });
            console.error(`get-accounting_err:${error.Status}`);
          });
      } catch (error) {
        commit(SET_ACCOUNTING_USER_CREDITS, { credits: null });
        console.error(`get_accounting_err:${error.Status}`);
        throw error;
      }
    },
    [FETCH_USER_CREDIT_BY_ID]: async ({ commit }, payload) => {
      try {
        const { userId } = payload;
        return await getAccountingUserCreditById(userId)
          .then((resp) => {
            commit(SET_SELECTED_USER_CREDIT, { credit: resp.data[0] });
          }).catch((error) => {
            commit(SET_SELECTED_USER_CREDIT, { credit: null });
            console.error(`get-accounting_err:${error.Status}`);
          });
      } catch (error) {
        commit(SET_SELECTED_USER_CREDIT, { credit: null });
        console.error(`get_accounting_err:${error.Status}`);
        throw error;
      }
    },
    [FETCH_INVOICE_BY_ID]: async ({ commit }, payload) => {
      try {
        commit(SET_SELECTED_INVOICE, { invoice: null });
        const { invoiceId } = payload;
        await getInvoiceById(invoiceId)
          .then((resp) => {
            commit(SET_SELECTED_INVOICE, { invoice: resp });
          }).catch((error) => {
            commit(SET_SELECTED_INVOICE, { invoice: null });
            console.error(`gettransaction_err:${error.Status}`);
          });
      } catch (error) {
        commit(SET_SELECTED_INVOICE, { invoice: null });
        console.error(`gettrasaction_err:${error.Status}`);
        throw error;
      }
    },

    [FETCH_ORIGINAL_INVOICE_BY_ID]: async ({ commit }, payload) => {
      try {
        const { invoiceId } = payload;
        await getInvoiceById(invoiceId)
          .then((resp) => {
            commit(SET_SELECTED_ORIGINAL_INVOICE, { invoice: resp.data[0] });
          }).catch((error) => {
            commit(SET_SELECTED_ORIGINAL_INVOICE, null);
            console.error(`gettransaction_err:${error.Status}`);
          });
      } catch (error) {
        commit(SET_SELECTED_ORIGINAL_INVOICE, null);
        console.error(`gettrasaction_err:${error.Status}`);
        throw error;
      }
    },

    [FETCH_ORIGINAL_INVOICE_BY_NUMBER]: async ({ commit }, payload) => {
      try {
        const { invoiceNumber } = payload;
        await getInvoiceByNumber(invoiceNumber)
          .then((resp) => {
            commit(SET_SELECTED_ORIGINAL_INVOICE, { invoice: resp.data[0] });
          }).catch((error) => {
            commit(SET_SELECTED_ORIGINAL_INVOICE, null);
            console.error(`gettransaction_err:${error.Status}`);
          });
      } catch (error) {
        commit(SET_SELECTED_ORIGINAL_INVOICE, null);
        console.error(`gettrasaction_err:${error.Status}`);
        throw error;
      }
    },

    [GET_SELECTED_INVOICE_COMPANY_BY_USERID]: async ({ commit }, payload) => {
      try {
        commit(SET_SELECTED_INVOICE_COMPANY, { company: null });
        const { userId } = payload;
        const resp = await getUserInCompaniesbyUserId(userId);
        if (resp.data !== null && resp.data !== '') {
          const data = await getUserCompanyDatabyComapanyId(resp.data.companyId);
          commit(SET_SELECTED_INVOICE_COMPANY, { company: data.data });
        }
      } catch (error) {
        commit(SET_SELECTED_INVOICE_COMPANY, { company: null });
        console.error(`get_company_err:${error.Status}`);
        throw error;
      }
    },
    [GET_SELECTED_USER_COMPANY_BY_USERID]: async ({ commit }, payload) => {
      try {
        commit(SET_SELECTED_USER_COMPANY, { company: null });
        const { userId } = payload;
        const resp = await getUserInCompaniesbyUserId(userId);
        if (resp.data !== null && resp.data !== '') {
          const data = await getUserCompanyDatabyComapanyId(resp.data.companyId);
          commit(SET_SELECTED_USER_COMPANY, { company: data.data });
        }
      } catch (error) {
        commit(SET_SELECTED_USER_COMPANY, { company: null });
        console.error(`get_company_err:${error.Status}`);
        throw error;
      }
    },

    [FETCH_ACCOUNTING_PAYMENT_TYPES]: async ({ commit }) => {
      try {
        return await getAccountingPaymentTypes()
          .then((resp) => {
            commit(SET_ACCOUNTING_PAYMENT_TYPES, { types: resp.data });
          }).catch((error) => {
            commit(SET_ACCOUNTING_PAYMENT_TYPES, { types: null });
            console.error(`get-accounting_err:${error.Status}`);
          });
      } catch (error) {
        commit(SET_ACCOUNTING_PAYMENT_TYPES, { types: null });
        console.error(`get_accounting_err:${error.Status}`);
        throw error;
      }
    },
    [FETCH_ACCOUNTING_CREDITCARD_TYPES]: async ({ commit }) => {
      try {
        return await getAccountingCreditCardTypes()
          .then((resp) => {
            commit(SET_ACCOUNTING_CREDITCARD_TYPES, { types: resp.data });
          }).catch((error) => {
            commit(SET_ACCOUNTING_CREDITCARD_TYPES, { types: null });
            console.error(`get-accounting_err:${error.Status}`);
          });
      } catch (error) {
        commit(SET_ACCOUNTING_CREDITCARD_TYPES, { types: null });
        // console.error(`get_accounting_err:${error.Status}`);
        throw error;
      }
    },
    [PROCESS_INVOICE_APPROVE]: async (_, payload) => {
      try {
        const { data } = payload;
        // console.log('update-data:', data);
        await processInvoiceApprove(data);
      } catch (error) {
        console.error(`process_approve_err:${error.Status}`);
        throw error;
      }
    },
    [PROCESS_INVOICE_GROUP]: async (_, payload) => {
      try {
        const { data } = payload;
        // console.log('update-data:', data);
        await processInvoiceGroup(data);
      } catch (error) {
        console.error(`process_gropu_approve_err:${error.Status}`);
        throw error;
      }
    },
    [PROCESS_INVOICE_RESET_PAYMENT_TYPE]: async (_, payload) => {
      try {
        const { data } = payload;
        // console.log('update-data:', data);
        await processInvoiceResetPaymentType(data);
      } catch (error) {
        console.error(`process_resetpayment_err:${error.response.data.message}`);
        throw error;
      }
    },
    [PROCESS_INVOICE_CANCEL]: async (_, payload) => {
      try {
        const { data } = payload;
        // console.log('update-data:', data);
        await processInvoiceCancel(data);
      } catch (error) {
        console.error(`process_cancellation_err:${error.Status}`);
        throw error;
      }
    },
    [PROCESS_INVOICE_WO]: async (_, payload) => {
      try {
        const { data } = payload;
        // console.log('update-data:', data);
        await processInvoiceWO(data);
      } catch (error) {
        console.error(`process_cancellation_err:${error.Status}`);
        throw error;
      }
    },
    [PROCESS_INVOICE_REFUND]: async (_, payload) => {
      try {
        const { data } = payload;
        // console.log('update-data:', data);
        const resp = await processInvoiceRefund(data);
        console.log('refund posted:', resp.data);
        return resp.data;
      } catch (error) {
        console.error(`process_refund_err:${error.Status}`);
        throw error;
      }
    },
    [PROCESS_USER_CREDIT]: async (_, payload) => {
      try {
        const { data } = payload;
        // console.log('update-data:', data);
        await processUserCredit(data);
      } catch (error) {
        console.error(`process_invoice_err:${error.Status}`);
        throw error;
      }
    },
    [GET_OPEN_PERMITS]: async ({ commit }) => {
      try {
        commit(SET_OPEN_PERMITS, { openPermits: null });
        const resp = await getOpenPermits();
        const { data } = resp;
        commit(SET_OPEN_PERMITS, { openPermits: data });
        return resp;
      } catch (error) {
        console.error(`get_open_permits:${error.Status}`);
        throw error;
      }
    },
    [GET_PRODUCTS]: async ({ commit }) => {
      try {
        commit(SET_PRODUCTS, { products: null });
        const resp = await getProducts();
        const { data } = resp;
        commit(SET_PRODUCTS, { products: data });
        return resp;
      } catch (error) {
        console.error(`get_products:${error.Status}`);
        throw error;
      }
    },
    [GET_PRODUCTS_BY_CATEGORY]: async ({ commit }, payload) => {
      try {
        commit(SET_PRODUCTS_BY_CATEGORY, { products: null });
        const category = payload;
        const resp = await getProductsByCategory(category);
        commit(SET_PRODUCTS_BY_CATEGORY, { products: resp?.data });
        return resp.data;
      } catch (error) {
        console.error(error);
        commit(SET_PRODUCTS_BY_CATEGORY, { products: null });
        throw error;
      }
    },
    [GET_PRODUCTS_TYPE_LIST]: async ({ commit }) => {
      try {
        commit(SET_PRODUCTS_TYPE_LIST, { products: null });
        const resp = await getProductTypeList();
        commit(SET_PRODUCTS_TYPE_LIST, { products: resp?.data });
        return resp.data;
      } catch (error) {
        console.error(error);
        commit(SET_PRODUCTS_TYPE_LIST, { products: null });
        throw error;
      }
    },
    [GET_PRICE_BY_PRODUCTID]: async ({ commit }, payload) => {
      try {
        commit(SET_PRICE_BY_PRODUCTID, { productPrice: null });
        const productID = payload;
        const resp = await getPriceByProductID(productID);
        commit(SET_PRICE_BY_PRODUCTID, { productPrice: resp?.data });
        return resp.data;
      } catch (error) {
        console.error(error);
        commit(SET_PRICE_BY_PRODUCTID, { productPrice: null });
        throw error;
      }
    },
    [GET_OP_FEE]: async ({ commit }) => {
      try {
        commit(SET_OP_FEE, { opFeeList: null });
        const resp = await getOPFeeList();
        commit(SET_OP_FEE, { opFeeList: resp?.data });
        return resp.data;
      } catch (error) {
        console.error(error);
        commit(SET_OP_FEE, { opFeeList: null });
        throw error;
      }
    },
    [GET_OP_FEE_BY_ID]: async ({ commit }, payload) => {
      try {
        commit(SET_OP_FEE_BY_ID, { opFeeList: null });
        const registrationId = payload;
        const resp = await getOPFeeByID(registrationId);
        commit(SET_OP_FEE_BY_ID, { opFeeList: resp?.data });
        return resp.data;
      } catch (error) {
        console.error(error);
        commit(SET_OP_FEE_BY_ID, { opFeeList: null });
        throw error;
      }
    },
    [SET_INVOICE]: async (_, payload) => {
      try {
        const { data } = payload;
        await setInvoice(data);
      } catch (error) {
        console.error(`set_invoice:${error}`);
        throw error;
      }
    },
  },
};
